// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import HousePhotosActionType from './house-photos.types';

const INITIAL_STATE = {
	// House Photos Response
	updateHousePhotosResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** update House Photos Start ************************/
		case HousePhotosActionType.UPDATE_HOUSE_PHOTOS_SUCCESS:
			return { ...state, updateHousePhotosResponse: action.payload };

		case HousePhotosActionType.UPDATE_HOUSE_PHOTOS_FAILURE:
			return { ...state, updateHousePhotosResponse: action.payload };

		case HousePhotosActionType.UPDATE_HOUSE_PHOTOS_RESPONSE_CHANGED:
			return { ...state, updateHousePhotosResponse: null };
		/** ***************** update House Photos End ************************/

		default:
			return state;
	}
};
